import axios from 'axios';
import * as types from "../constants";

export const getChartTitles = (year) => async dispatch => {
  try {
    const res = await axios.post('/api/mums/list', { year })

    dispatch({
      type: types.GET_MUM_CHART_TITLES,
      payload: res.data
    })
  } catch (e) {
    console.error(e);
  }
}

export const getYears = () => async dispatch => {
  try {
    const res = await axios.get('/api/mums/years');
    let o = []
    for(let i of res.data) {
      console.log(i)
      o.push({ "value": i.year, "label": i.year })
    }

    dispatch({
      type: types.GET_MUM_YEARS,
      payload: o
    })
  } catch (e) {
    console.error(e);
  }
}

export const getChart = (chartId) => async dispatch => {
  try {
    let res = await axios.post('/api/mums/search', {chartId});
    dispatch({
      type: types.SELECT_MUM_CHART,
      payload: res.data

    })
  } catch (e) {
    console.error(e);
  }
}

export const createNew = (data) => async dispatch => {
  try {
    let res = await axios.post('/api/mums/newMum', data)
    dispatch({
      type: types.CREATE_MUM_CHART,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const copyChart = (data) => async dispatch => {
  try {
    let res = await axios.post('/api/mums/copyMum', data)
    dispatch({
      type: types.COPY_MUM_CHART,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const editChart = ( id, data) => async dispatch => {
  try {
    let res = await axios.post('/api/mums/updateMum', {id, data})
    dispatch({
      type: types.EDIT_MUM_CHART,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const addChemicals = (id, data) => async dispatch => {
  try {
    console.log(id, data);
    let res = await axios.post('/api/mums/addChemical', {id, data})
    dispatch({
      type: types.ADD_MUM_CHEMICAL,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const addMeasurement = (id, data) => async dispatch => {
  try {
    let res = await axios.post('/api/mums/addMeasurement', {id, data})
    dispatch({
      type: types.ADD_MUM_MEASUREMENT,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const addLevel = (id, data) => async dispatch => {
  try {
    let res = await axios.post('/api/mums/addLevel', {id, data})
    console.log(res)
    dispatch({
      type: types.ADD_MUM_LEVEL,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const clearMum = () => async dispatch => {
  dispatch({
    type: types.CLEAR_MUM
  })
}

export const deleteChart = (id) => async dispatch => {
  try {
    let res = await axios.post('/api/mums/deleteChart', {id:id});
    console.log(res)
    dispatch({
      type: types.DELETE_MUM_CHART
    })
  } catch(e) {
    console.error(e);
  }
}

export const updateTable = (table, index, e)=> async dispatch => {
  let name = e.target.name;
  let value = e.target.value;
  if(name === ("measurement" || "ph" || "ec")){
    table[index][name] = Number(value);
  } else {
    table[index][name] = value;
  }

  dispatch({
    type: types.UPDATE_MUM_TABLE,
    payload: table
  })
}

export const saveTable = (id, table) => async dispatch => {
  try {
    let res = await  axios.post('/api/mums/saveTable', {id, table});
    dispatch({
      type: types.SAVE_MUM_TABLE,
      payload: res.data
    })
    console.log(res);
  } catch (e) {

  }
}

export const changeDate = (e) => async dispatch => {
  console.log(e)
  dispatch({
    type: types.CHANGE_MUM_DATE,
    payload: e.value
  })
}

export const mumCleanUp = () => async dispatch => {
  dispatch({
    type: types.MUM_CLEAN_UP
  })
}
